import httpClient from '@/http-client'

export const getProfile = (Options = {}) => {
  return httpClient
    .get('/api/home/teacher-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changePassword = data => {
  return httpClient
    .post('/api/home/teacher-change-passwords', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/teacher-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTotalMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/teacher-get-total-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApproveTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/teacher/approve-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getClasses = (Option = {}) => {
  return httpClient
    .get('/api/home/teacher/get-classes', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubjects = (Option = {}) => {
  return httpClient
    .get('/api/home/teacher/get-subjects', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/teacher/get-notification-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/teacher/notification-types', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getClassOperation = (Options = {}) => {
  return httpClient
    .get('/api/home/teacher/class-operations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const schedule = (Options = {}) => {
  return httpClient
    .get('/api/home/teacher/schedules/', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getProfile,
  changePassword,
  getMyRequest,
  getTotalMyRequest,
  getApproveTypes,
  getClasses,
  getSubjects,
  getNotificationHistory,
  getNotificationTypes,
  getClassOperation,
  schedule
}
